import React from 'react';
import { Product } from './useProductsList';
import { Schema } from '../../../toolympus/hooks/useSchema';
import { NewItemProps } from '../../../toolympus/api/useNewItem';
import { SimpleDialog, FormGrid } from '../../../toolympus/components/primitives';
import { FormControlsForFields } from '../../../toolympus/components/schemed';

interface Props extends NewItemProps<Partial<Product>, Product> {
  schema: Schema;
}

export const CreateProduct = (props: Props) => {
  const { isEditing, cancel, errors, item, update, save, schema } = props;
  return (
    <SimpleDialog
      isOpen={isEditing}
      close={cancel}
      dialogTitle="New product"
      submitOnModEnter
      noFullscreen
      save={() => save()}>
      {item && <FormGrid columns="1fr">
        <FormControlsForFields
          fields={[
            ["title"],
          ]}
          data={item}
          onChange={(o,c) => update(c)}
          errors={errors}
          schema={schema}
          />
        
      </FormGrid>}
    </SimpleDialog>
  );
}

